import type React from 'react'

import Pill from '@/components/Pill'
import type { AddressreferenceOutcome } from '@/types/Landlord'
interface Props {
  label: AddressreferenceOutcome
}

const LandlordStatusPill: React.FC<Props> = ({ label }) => {
  switch (label) {
    case 'Invalid':
    case 'Rejected':
    case 'Fail':
      return <Pill type="negative">{label}</Pill>
    case 'Pass':
      return <Pill type="positive">{label}</Pill>
    case 'ConditionalPass':
      return <Pill type="positive">Conditional Pass</Pill>
    default:
      return <Pill type="neutral">{label}</Pill>
  }
}

export default LandlordStatusPill
